import React, { FunctionComponent } from 'react'
import { DateField } from './FieldTypes/DateField';
import DropdownField from './FieldTypes/DropdownField';
import NumericField from './FieldTypes/NumericField';
import TextField from './FieldTypes/TextField';
import { Field, FieldRenderProps, FieldWrapper, } from '@progress/kendo-react-form';
import { ClientField } from './FieldTypes/ClientField';
import { StaffField } from './FieldTypes/StaffField';
import { Label, Error, Hint } from "@progress/kendo-react-labels";
import { TimeField } from './FieldTypes/TimeField';
import { EndUserField } from './FieldTypes/EndUserField';
const FormField: FunctionComponent<FieldRenderProps> = formRenderProps => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    showHint,
    optional,
    field,
    ...others
  } = formRenderProps;
  const labelValid = !validationMessage;
  const hintId = showHint ? `${id}_hint` : "";
  const errorId = validationMessage ? `${id}_error` : "";
  let description = field.Description && !field.Show_Tooltip && (
    <Hint>
      {field.Description}
    </Hint>
  )

  //Show tooltip popup
  const tool = (
    field.Show_Tooltip && field.Description &&
    <span className='k-font-icon k-i-info' title={field.Description} ></span>
  )

  const renderField = () => {
    switch (field.Field_Type_Id) {
      case 1:
        return TextField
      case 2:
        return DropdownField
      case 3:
        return DateField
      case 4:
        return TimeField
      case 5:
        return NumericField
      case 6:
        return StaffField
      case 7:
        return ClientField
      case 8:
        return EndUserField
      case 9:
        return NumericField
      default:
        return Error
    }
  }
  return (
    <FieldWrapper>
      <Label
        editorId={id}
        editorValid={labelValid}
        editorDisabled={disabled}
        optional={optional}
      >
        {tool} {field.Name} {validationMessage && (<Error id={errorId}>&nbsp;{validationMessage}</Error>)}
      </Label>
      {/* <em>{JSON.stringify(field.Is_Required)} - valid:{JSON.stringify(field.Required_To)} - {validationMessage}</em> */}
      {description}
      <Field
        {...others}
        field={field}
        id={id}
        name={id}
        component={renderField()}
      />
      <Hint id={hintId}>{hint}</Hint>

    </FieldWrapper>
  )
}

export default FormField;